import { inject, Injectable } from '@angular/core';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '../config.token';
import { HttpClient } from '@angular/common/http';
import { PassportForCareStatusDto } from '@web/csl-lib-models';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PassportForCareService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl!: string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getStatus(healthRecordId: string): Observable<PassportForCareStatusDto> {
    return this.http.get<PassportForCareStatusDto>(
      `${this.apiUrl}/HealthRecords/${healthRecordId}/PFC/Status`
    );
  }

  submitScp(healthRecordId: string, documentId: string, userConsented: boolean): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/HealthRecords/${healthRecordId}/PFC/SubmitScp`,
      { healthRecordFileStoreId: documentId, userConsented }
    );
  }
}
